'use client';

import { getLanguageFromLocale } from '@bomdisoft/translations';
import s from '@pieleaf/app/[lang]/home/sections/sourcing/styles.module.css';
import { sourcingDirectBody, sourcingDirectLabel, sourcingLiveBody, sourcingLiveLabel, sourcingNote, sourcingTitle, sourcingTransparentBody, sourcingTransparentLabel } from '@pieleaf/translations';
import { useParams } from 'next/navigation';

export const SourcingSection = () => {
  const params = useParams();
  const language = getLanguageFromLocale(typeof params.lang === 'string' ? params.lang : 'en');

  const rows = [
    { body: sourcingDirectBody, label: sourcingDirectLabel, testId: 'sourcing-direct' },
    { body: sourcingTransparentBody, label: sourcingTransparentLabel, testId: 'sourcing-transparent' },
    { body: sourcingLiveBody, label: sourcingLiveLabel, testId: 'sourcing-live' },
  ];

  return (
    <section className={s.section} data-testid='sourcing-section'>
      <div className={s.inner}>
        <div className={s.head}>
          <h2 className={s.heading}>{sourcingTitle[language]}</h2>
          <span className={s.note}>{sourcingNote[language]}</span>
        </div>

        <div className={s.rows}>
          {rows.map(row => (
            <div className={s.row} data-testid={row.testId} key={row.testId}>
              <p className={s.label}>{row.label[language]}</p>
              <p className={s.body}>{row.body[language]}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
